import { Pipe, PipeTransform } from '@angular/core';

const memberModel = {
	country: String,
	email: String,
	firstName: String,
	group: String,
	groupId: Number,
	id: Number,
	lastName: String,
	multimedia: String,
	name: String,
	onStartMail: Boolean,
	profileId: Number,
	selected: Boolean,
	slack: String,
	welcomeMail: Boolean,
};

@Pipe({
	name: 'selectedMembers',
	pure: false,
})
export class AddMembersPipe implements PipeTransform {
	public transform(allHeroes: typeof memberModel[]): any {
		return allHeroes.filter(hero => {
			if (hero.selected) {
				return hero;
			}
		});
	}
}
